import { render, staticRenderFns } from "./DevolutionsSmall.vue?vue&type=template&id=5661ed95&"
import script from "./DevolutionsSmall.vue?vue&type=script&lang=js&"
export * from "./DevolutionsSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports